import React from "react";
import { Circle, XStack, YStack } from "tamagui";

import { GradientCard } from "./GradientCard";
import { SkeletonBox } from "./SkeletonBox";

// Mirrors KPICard's shape (icon circle + title/description column) inside the
// same GradientCard shell so padding/border/background match the loaded tile
// exactly and nothing shifts on swap. Static only — no animation.
export const KPITileSkeleton: React.FC = () => (
  <GradientCard
    flex={1}
    backgroundColor="$transparentBorder"
    backgroundImage="none"
    $lg={{ flexBasis: "40%" }}
    $xs={{ flexBasis: "100%" }}
  >
    <XStack gap="$3.5" alignItems="center">
      <Circle size={56} backgroundColor="$transparentBorder" />
      <YStack gap="$1.5" flex={1} justifyContent="center">
        <SkeletonBox height={16} width="60%" />
        <SkeletonBox height={12} width="40%" />
      </YStack>
    </XStack>
  </GradientCard>
);
